import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

export const resetMarkerPriceServiceStation = (): AnyAction => stationsActions.setMarkerServiceStations();
export const resetPricesServiceMapData = (): AnyAction => stationsActions.setPricesServiceMapData();
